import type { EqmsController } from "../../../controllers/useEqms";
import type { ProjectMember } from "../../../models/account";
import { EqmsDashboardView } from "./EqmsDashboardView";
import { EqmsSprintBoardView } from "./EqmsSprintBoardView";
import { EqmsWorkAreaView } from "./EqmsWorkAreaView";
import { EqmsDocumentsView } from "./EqmsDocumentsView";
import { EqmsDocumentDetailView } from "./EqmsDocumentDetailView";
import { EqmsVersionsView } from "./EqmsVersionsView";
import { EqmsDesignTestView } from "./EqmsDesignTestView";
import { EqmsInboxView } from "./EqmsInboxView";
import { EqmsExternalView } from "./EqmsExternalView";
import { EqmsAdminView } from "./EqmsAdminView";
import { EqmsTraceView } from "./EqmsTraceView";
import { EqmsRiskView } from "./EqmsRiskView";
import { EqmsAttachmentsView } from "./EqmsAttachmentsView";

// Section router for the eQMS surface: each section screen owns its own data loading via eqmsApi +
// eqms.getToken, mirroring how IssuesView drives itself from useIssues. The app renders this directly
// (see App.tsx); the workspace/project picker + nav-tree shell once wrapping it (EqmsView /
// EqmsProjectPicker / EqmsProjectShell) was removed as dead code once the router became the entry point.
export function EqmsSectionRouter({ eqms, members, currentUserId }: {
  eqms: EqmsController;
  members: ProjectMember[];
  /** The acting user — a review request must not let them review/approve their own document. */
  currentUserId: string | null;
}) {
  switch (eqms.section) {
    case "dashboard":
      return <EqmsDashboardView eqms={eqms} />;
    case "sprint":
      return <EqmsSprintBoardView eqms={eqms} members={members} />;
    case "workarea":
      return <EqmsWorkAreaView eqms={eqms} members={members} />;
    case "documents":
      return eqms.detailId
        ? <EqmsDocumentDetailView eqms={eqms} currentUserId={currentUserId} />
        : <EqmsDocumentsView eqms={eqms} />;
    case "versions":
      return <EqmsVersionsView eqms={eqms} />;
    case "design":
      return <EqmsDesignTestView eqms={eqms} mode="design" />;
    case "test":
      return <EqmsDesignTestView eqms={eqms} mode="test" />;
    case "trace":
      return <EqmsTraceView eqms={eqms} />;
    case "risk":
      return <EqmsRiskView eqms={eqms} />;
    case "attachments":
      return <EqmsAttachmentsView eqms={eqms} />;
    case "inbox":
      return <EqmsInboxView eqms={eqms} />;
    case "external":
      return <EqmsExternalView eqms={eqms} />;
    case "admin":
      return <EqmsAdminView eqms={eqms} />;
    default:
      return null;
  }
}
